import { ILeaderboardRow } from '../logic';

export class LeaderboardConfig {
  public static readonly secondInterval = 10;
  public static readonly minPercentageOfRawPointsToDuration = 0.6;
  public static readonly minProcessedLoad = 10;
  public static readonly numberOfWorkoutsInHomeGroupClass = 9;
  public static readonly randomBucketSize = 5;
  public static readonly lifespanOfWorkoutLeaderboardHour = 2;
  public static readonly startOfFirstSection = 0;
  public static readonly getStartOfLastSection = (leaderboardRows: ILeaderboardRow[]) =>
    leaderboardRows.length - 2
  public static readonly getEndOfLastSection = (leaderboardRows: ILeaderboardRow[]) =>
    leaderboardRows.length
}
